// Whether a widget runs on the v2 engine. Needs both the widget setting and a context where the
// feature is enabled; otherwise the widget keeps using its legacy datasource.
export const selectUsesDatasourceV2 = (widgetId) => (state) => (
  state.dashboard.datasourceV2Enabled && state.dashboard.widgets[widgetId]?.datasource_v2_id != null
);
